let ResizableChart = require("./ResizableChart");

let { Tabs, IconButton } = mc.widgets;

class Timeline extends ResizableChart {
  constructor(props) {
    super(props);

    this.state.zoomed = false;
    this.state.zoomTs = null;
    this.state.zoomHrs = 1;
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.renderChart(nextProps, nextState);

    return true;
  }

  renderChart(props, state) {
    let { timezone, breakTs, onFollow } = props;

    let scale = this.getScale(props, state);

    let rootNode = d3.select(this.refs.timeline);
    let hitNode = rootNode.select(".rc-timeline-hit");
    let needleNode = rootNode.select(".rc-timeline-needle");
    let xAxisNode = rootNode.select(".rc-timeline-x-axis");
    let datelineNode = rootNode.select(".rc-timeline-dateline");

    let mousemove = () => {
      let [x] = d3.mouse(hitNode.node());
      let txt = mc.format.time(scale.invert(x - 40), timezone);

      if (x > 40) {
        needleNode.attr("transform", "translate(" + x + ")");
        needleNode.select("text").text(txt);
      }
    };

    let mouseup = () => {
      let { zoomed } = state;
      let [x] = d3.mouse(hitNode.node());
      let zoomTs = scale.invert(x - 40).valueOf();

      if (x > 40) {
        this.setState({ zoomed: !zoomed, zoomTs }, mousemove);
      }
    };

    needleNode.on("mouseup", () => {
      let point = d3.mouse(hitNode.node());
      let startTs = scale.invert(point[0] - 40).valueOf();

      onFollow(startTs);
    });

    rootNode
      .on("mousemove", mousemove)
      .on("mouseup", mouseup);

    xAxisNode.transition().call(
      d3.axisBottom()
        .scale(scale)
        .ticks(10)
        .tickFormat(function (d) {
          return mc.format.time(d, timezone);
        })
    );

    datelineNode
      .attr("transform", "translate(" + scale(breakTs) + ")");
  }

  page(direction) {
    let { startTs, stopTs } = this.props;
    let { zoomTs, zoomHrs } = this.state;

    let pageMillis = zoomTs + (mc.math.MILLIS_PER_HOUR * zoomHrs * direction / 2);

    this.setState({
      zoomTs: mc.math.limit(pageMillis, startTs, stopTs)
    });
  }

  setZoom(zoomHrs, changed) {
    if (changed) {
      this.setState({ zoomHrs });
    }
  }

  getScale(props, state) {
    let { startTs, stopTs } = props;
    let { width, zoomed, zoomTs, zoomHrs } = state;

    let domain = [startTs, stopTs];
    let range = [0, width - 40];

    if (zoomed) {
      let pct = (zoomTs - startTs) / (stopTs - startTs);
      let a = zoomTs + ((mc.math.MILLIS_PER_HOUR * zoomHrs) * -pct);
      let b = a + (mc.math.MILLIS_PER_HOUR * zoomHrs);

      domain = [a, b];
    }

    return d3.scaleUtc().domain(domain).range(range);
  }

  render() {
    let { startTs, stopTs, children } = this.props;
    let { width, zoomed, zoomHrs } = this.state;
    let scale = this.getScale(this.props, this.state);
    let y = 0;
    let domain = scale.domain();
    let pageBack = domain[0] <= startTs ? null : this.page.bind(this, -1);
    let pageNext = domain[1] >= stopTs ? null : this.page.bind(this, 1);
    let transform = (x, y) => `translate(${x}, ${y})`;

    let opts = [
      { label: "1h", value: 1 },
      { label: "2h", value: 2 },
      { label: "3h", value: 3 }
    ];

    let rows = React.Children.map(children, function (child, i) {
      let { icon, height, label, unit } = child.props;
      let href = "./img/rc/report." + icon + ".svg";

      let component = (
        <g key={i} transform={transform(0, y)}>
          <g transform={transform(0, (height / 2) - 18)} className="rc-timeline-icon">
            <image xlinkHref={href} width="36" height="36" data-tooltip={label}/>
            <text x="18" y="40" textAnchor="middle">
              {unit}
            </text>
          </g>
          <g transform={transform(40, 0)} clipPath="url(#rc-timeline-clip)">
            { React.cloneElement(child, { width: width - 40, scale, zoomed }) }
          </g>
        </g>
      );

      y += height + 10;

      return component;
    });

    let height = y + 50;

    return (
      <div>
        <div className="rc-timeline-nav">
          <Tabs options={opts} value={zoomHrs} onSelect={this.setZoom.bind(this)} disabled={!zoomed}/>
          <IconButton icon="back" onPress={pageBack} disabled={!pageBack}/>
          <IconButton icon="forward" onPress={pageNext} disabled={!pageNext}/>
        </div>

        <svg ref="timeline" className="rc-timeline" data-zoomed={zoomed} width={width} height={height + 5}>
          <defs>
            <clipPath id="rc-timeline-clip">
              <rect x="0" width={width} height={height}/>
            </clipPath>
            <clipPath id="rc-timeline-axis-clip">
              <rect x="40" width={width} height={height}/>
            </clipPath>
          </defs>

          <rect className="rc-timeline-no-hit" x="0" width={40} height={height}/>
          <rect className="rc-timeline-hit" x="40" width={width - 40} height={height}/>

          <g>
            {rows}
          </g>

          <g clipPath="url(#rc-timeline-axis-clip)">
            <g className="rc-timeline-x-axis" transform={transform(40, height - 50)}/>
            <line className="rc-timeline-dateline" x1={40} x2={40} y2={height - 50}/>
          </g>

          <g className="rc-timeline-needle" transform={transform(40, 0)}>
            <line y2={height - 25}/>
            <g transform={transform(0, height - 25)}>
              <rect x="-50" width="100" height="22" rx="11" ry="11"/>
              <text y="15" textAnchor="middle"/>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

module.exports = Timeline;